import reactDom from './morph/react-dom.js'
import reactNative from './morph/react-native.js'
import e2e from './morph/e2e.js'

export default {
  'react-dom': reactDom,
  'react-native': reactNative,
  e2e,
}
